import { createError } from '../../../../../lib/error';

class PositionSearchModalController {
  constructor(
    $scope,
    $uibModalInstance,
    $translate,
    $q,
    DEBUG,
    staffUser
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$translate = $translate;
    this.$q = $q;
    this.DEBUG = DEBUG;
    this.staffUser = staffUser;
  }

  close() {
    this.$uibModalInstance.close();
  }
}

export default PositionSearchModalController;
